(function initializeBlogAttribution() {
  "use strict";
  if (window.__storeBlogAttribution) return;
  var VERSION = "2026-10-27.1";
  var UTM = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"];
  var KEYS = { article: "__blog_article__", path: "__blog_path__", at: "__blog_at__" };
  var STORE = "store_blog_attribution_v1", TTL = 30 * 864e5;
  var initial = new URL(window.location.href), record = null, saved = "", pending2 = null;
  function slug(value) {
    return typeof value === "string" && value.length <= 180 && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value);
  }
  function blogPath2(value) {
    return /^\/blogs\/[^/?#]+\/[a-z0-9-]+\/?$/.test(value || "") ? value.replace(/\/$/, "") : "";
  }
  function preserveUrl(target, current) {
    var next = new URL(target, current.href);
    if (next.origin !== current.origin || !/^\/products\//.test(next.pathname)) return target;
    if (next.searchParams.has("utm_source") && next.searchParams.get("utm_source") !== current.searchParams.get("utm_source")) return target;
    UTM.forEach(function(key2) {
      if (!next.searchParams.has(key2) && current.searchParams.has(key2)) next.searchParams.set(key2, current.searchParams.get(key2));
    });
    return next.href;
  }
  ["replaceState", "pushState"].forEach(function(method) {
    var original = window.history[method];
    window.history[method] = function() {
      var args = Array.prototype.slice.call(arguments), current = new URL(window.location.href);
      if (args.length > 2 && args[2] != null && /^\/products\//.test(current.pathname)) {
        try {
          args[2] = preserveUrl(args[2], current);
        } catch (_) {
        }
      }
      return original.apply(this, args);
    };
  });
  document.addEventListener("click", function(event) {
    var anchor = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    if (!anchor) return;
    try {
      anchor.href = preserveUrl(anchor.href, new URL(window.location.href));
    } catch (_) {
    }
  }, true);
  function allowed() {
    try {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (_) {
      return false;
    }
  }
  function valid(value) {
    var at = Date.parse(value && value.at);
    return value && value.origin === initial.origin && slug(value.article) && Number.isFinite(at) && at <= Date.now() + 3e5 && Date.now() - at <= TTL;
  }
  function seed() {
    var path = blogPath2(initial.pathname), article = path ? path.split("/").pop() : initial.searchParams.get("utm_source") === "blog" ? initial.searchParams.get("utm_campaign") : "";
    if (!slug(article)) return null;
    return { origin: initial.origin, article, path, at: (/* @__PURE__ */ new Date()).toISOString() };
  }
  function cartWrite(attributes) {
    var root4 = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    return fetch(root4 + "cart/update.js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes }), keepalive: true }).then(function(response) {
      if (!response.ok) throw new Error("cart unavailable");
    });
  }
  function persist() {
    if (!allowed() || !valid(record)) return Promise.resolve(false);
    var attributes = {};
    attributes[KEYS.article] = record.article;
    attributes[KEYS.path] = record.path || "";
    attributes[KEYS.at] = record.at;
    var fingerprint = JSON.stringify(attributes);
    if (saved === fingerprint) return Promise.resolve(true);
    if (pending2) return pending2;
    pending2 = cartWrite(attributes).then(function() {
      saved = fingerprint;
      return true;
    }).catch(function() {
      return false;
    }).finally(function() {
      pending2 = null;
    });
    return pending2;
  }
  function consentChanged() {
    if (!allowed()) {
      var had = record;
      record = null;
      saved = "";
      try {
        had = had || JSON.parse(window.localStorage.getItem(STORE) || "null");
        window.localStorage.removeItem(STORE);
      } catch (_) {
      }
      if (had) {
        var clear = {};
        Object.keys(KEYS).forEach(function(k) {
          clear[KEYS[k]] = "";
        });
        Promise.resolve(pending2).finally(function() {
          cartWrite(clear).catch(function() {
          });
        });
      }
      return;
    }
    try {
      var previous = JSON.parse(window.localStorage.getItem(STORE) || "null");
      record = valid(previous) ? previous : null;
    } catch (_) {
    }
    var current = seed();
    if (current && (!record || current.article !== record.article)) record = current;
    if (valid(record)) {
      try {
        window.localStorage.setItem(STORE, JSON.stringify(record));
      } catch (_) {
      }
      persist();
    }
  }
  document.addEventListener("visitorConsentCollected", consentChanged);
  document.addEventListener("submit", function(event) {
    if (event.target && /\/cart(?:\/|$)/.test(event.target.action || "")) persist();
  }, true);
  document.addEventListener("cart:updated", persist);
  window.__storeBlogAttribution = { version: VERSION, preserveUrl, ready: persist };
  if (window.Shopify && window.Shopify.customerPrivacy && typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === "function") consentChanged();
  else if (window.Shopify && window.Shopify.loadFeatures) window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function(error2) {
    if (!error2) consentChanged();
  });
})();
